import { message } from "antd";
import { parseShortLinkPath } from "features/links/utils/shortLink";
import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * Точка входа для коротких ссылок prsb.me (prsb.me/p/... -> /#/r/...).
 * Вся цепочка предков уже закодирована в самом пути, поэтому разбор —
 * чисто клиентский, без обращений к бэкенду.
 */
const LinkResolverPage: React.FC = () => {
  const params = useParams();
  const [messageApi, contextHolder] = message.useMessage();

  const rawPath = params["*"] || "";
  const segments = rawPath.split("/").filter(Boolean);
  const route = parseShortLinkPath(segments);

  useEffect(() => {
    if (!route) {
      messageApi.error("Ссылка не распознана");
    }
  }, [route, messageApi]);

  return (
    <>
      {contextHolder}
      <Navigate
        to={route ? `${route.pathname}${route.hash}` : "/"}
        replace
      />
    </>
  );
};

export default LinkResolverPage;
